// PROP-754 (решение владельца 28.09, план §6.8 п. 31; оферта v0.6 п. 8.6): подтверждение ответственности при
// подключении моста к своему ИИ. Тексты — ws/012/podtverzhdenie-svoj-ii-v0.1.md (русский — дословно), английский —
// и казахский — черновой перевод (версия -draft), тот же, что в продукте. Язык текста выбирается в самом окне
// (легаси целиком не переведён на казахский, а подтверждаемый клиентом текст нужен на трёх языках, §6.8 п. 11).
// Вариант B — пользователь организации, C — потребитель.
import axiosIns from '@axios'

export const OWN_AI_VERSIONS = { ru: 'own-ai-v0.1', kk: 'own-ai-v0.1-draft', en: 'own-ai-v0.1-draft' }

export const CONSENT_LANGS = [{ value: 'kk', text: 'Қазақша' }, { value: 'ru', text: 'Русский' }, { value: 'en', text: 'English' }]

export function bridgeConsentText(lang, variant, org) {
  const o = org || '—'
  if (lang === 'kk') {
    const draftNote = 'Жоба аударма. Түпкілікті аударма жарияланғанға дейін орыс тіліндегі мәтін басым болады.'
    if (variant === 'C') {
      return {
        title: 'Өз ЖИ-іңізді қосу',
        intro: 'Сіз өз компьютеріңіздегі ЖИ-ге көпірді қосып жатырсыз.',
        points: [
          ['Деректер қайда кетеді.', 'Агент оқитын домендеріңіздің деректері модель провайдеріне — әдетте Қазақстан Республикасының шегінен тыс — сіздің онымен шартыңыздың немесе есептік жазбаңыздың талаптарымен беріледі.'],
          ['Бұл кімнің шешімі.', 'Провайдерді сіз таңдайсыз. Cubus сіздің тапсырмаңызды орындайды.'],
          ['Басқа адамдар туралы мәліметтер.', 'Деректеріңізде басқа адамдар туралы мәліметтер болса, оларды провайдерге тек құқығыңыз болған жағдайда беріңіз.'],
        ],
        check: 'Өз ЖИ-імді қосқанда деректер қайда кететінін түсінемін және оны өз таңдауым бойынша қосамын.',
        connect: 'Қосу',
        cancel: 'Бас тарту',
        draftNote,
      }
    }
    return {
      title: 'Көпірді қосу',
      intro: 'Сіз көпірді қосып жатырсыз: агент сіздің компьютеріңізде, провайдердің моделінде сіздің есептік жазбаңыз бойынша жұмыс істейді.',
      points: [
        ['Деректер қайда кетеді.', 'Агент оқитын домен деректері, соның ішінде дербес деректер, сіздің компьютеріңізге, одан модель провайдеріне түседі. Беру сіздің провайдердегі есептік жазбаңыздың талаптарымен, әдетте Қазақстан Республикасының шегінен тыс жүзеге асады. Кейбір тұтынушылық тарифтерде провайдер, егер сіз оның баптауларында рұқсат етсеңіз, әңгімелерді ұзағырақ сақтап, оқытуға пайдалануы мүмкін.'],
        ['Бұл кімнің шешімі.', `Көпірді сіз өз ұйымыңыздың «${o}» тапсырмасы бойынша қосасыз. Cubus бұл беруді таңдамайды және бақыламайды.`],
        ['Кім жауап береді.', 'Берудің заңдылығына сіздің ұйымыңыз жауап береді, ал сіз — оның алдында.'],
      ],
      check: `Растаймын: көпірді «${o}» ұйымының хабарымен және тапсырмасы бойынша қосамын. Көпір арқылы ұйымның беруге негізі жоқ деректерді бермеймін. Жұмыс деректері үшін ұйымым рұқсат еткен провайдер есептік жазбасын пайдаланамын.`,
      connect: 'Қосу',
      cancel: 'Бас тарту',
      draftNote,
    }
  }
  if (lang === 'en') {
    const draftNote = 'Draft translation. The Russian text prevails until the final translation is published.'
    if (variant === 'C') {
      return {
        title: 'Connecting your own AI',
        intro: 'You are connecting a bridge to AI on your own computer.',
        points: [
          ['Where the data goes.', 'Data of your domains that the agent reads is transferred to the model provider — as a rule, outside the Republic of Kazakhstan — under your contract or account with it.'],
          ['Whose decision it is.', 'You choose the provider. Cubus carries out your instruction.'],
          ['Information about other people.', 'If your data contains information about other people, transfer it to the provider only if you have the right to do so.'],
        ],
        check: 'I understand where the data goes when I connect my own AI, and I connect it by my own choice.',
        connect: 'Connect',
        cancel: 'Cancel',
        draftNote,
      }
    }
    return {
      title: 'Connecting the bridge',
      intro: 'You are connecting the bridge: the agent will run on your computer, on a provider\'s model under your own account.',
      points: [
        ['Where the data goes.', 'Domain data the agent reads, including personal data, will reach your computer and from there the model provider — under the terms of your account with the provider, as a rule outside the Republic of Kazakhstan. On some consumer plans the provider may keep conversations longer and use them for training if you allowed this in its settings.'],
        ['Whose decision it is.', `You connect the bridge on behalf of your organisation “${o}”. Cubus neither chooses nor controls this transfer.`],
        ['Who is responsible.', 'Your organisation is responsible for the lawfulness of the transfer, and you are responsible to it.'],
      ],
      check: `I confirm: I connect the bridge with the knowledge and on behalf of “${o}”. I do not transfer through the bridge data the organisation has no basis to transfer. For work data I use a provider account my organisation allows.`,
      connect: 'Connect',
      cancel: 'Cancel',
      draftNote,
    }
  }
  if (variant === 'C') {
    return {
      title: 'Подключение своего ИИ',
      intro: 'Вы подключаете мост к ИИ на своём компьютере.',
      points: [
        ['Куда уходят данные.', 'Данные ваших доменов, которые прочитает агент, передаются провайдеру модели — как правило, за пределы Республики Казахстан — на условиях вашего договора или учётной записи у него.'],
        ['Чьё это решение.', 'Провайдера выбираете вы. Cubus исполняет ваше поручение.'],
        ['Сведения о других людях.', 'Если в ваших данных есть сведения о других людях, передавайте их провайдеру, только если имеете на это право.'],
      ],
      check: 'Я понимаю, куда уходят данные при подключении своего ИИ, и подключаю его по своему выбору.',
      connect: 'Подключить',
      cancel: 'Отмена',
    }
  }
  return {
    title: 'Подключение моста',
    intro: 'Вы подключаете мост: агент будет работать на вашем компьютере, на модели провайдера по вашей учётной записи.',
    points: [
      ['Куда уходят данные.', 'Данные доменов, которые прочитает агент, в том числе персональные, попадут на ваш компьютер, а с него — провайдеру модели. Передача идёт на условиях вашей учётной записи у провайдера, как правило за пределы Республики Казахстан. На некоторых потребительских тарифах провайдер может хранить разговоры дольше и использовать их для обучения, если вы это разрешили в его настройках.'],
      ['Чьё это решение.', `Мост подключаете вы по поручению своей организации «${o}». Cubus эту передачу не выбирает и не контролирует.`],
      ['Кто отвечает.', 'За законность передачи отвечает ваша организация, а вы — перед ней.'],
    ],
    check: `Я подтверждаю: подключаю мост с ведома и по поручению «${o}». Через мост я не передаю данные, на передачу которых у организации нет основания. Для рабочих данных пользуюсь учётной записью провайдера, которую разрешает моя организация.`,
    connect: 'Подключить',
    cancel: 'Отмена',
  }
}

/** Нужно ли подтверждение моста (раз на пользователя и версию текста), вариант и имя организации. */
export async function bridgeConsentState() {
  const res = await axiosIns.get('/api/me/ai-consent', { params: { kind: 'ai_bridge' } })
  return (res && res.data) || { required: false, variant: 'B', orgName: '' }
}

export async function confirmBridgeConsent(lang) {
  const l = OWN_AI_VERSIONS[lang] ? lang : 'ru'
  const res = await axiosIns.post('/api/me/ai-consent', {
    kind: 'ai_bridge', confirm: true, version: OWN_AI_VERSIONS[l], lang: l,
  })
  return res && res.data
}
